import React, { useState } from 'react';
import { Modal, Input, Button, message } from 'antd';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../config/firebase';

const TempPasswordModal = ({ isOpen, onClose, userId }) => {
  const [tempPassword, setTempPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!tempPassword.trim()) {
      message.error('Please enter a temporary password');
      return;
    }

    setLoading(true);
    try {
      const userRef = doc(db, 'users', userId);
      await updateDoc(userRef, {
        tempPassword: tempPassword.trim()
      });
      message.success('Temporary password set successfully');
      setTempPassword('');
      onClose();
    } catch (error) {
      console.error('Error setting temporary password:', error);
      message.error('Failed to set temporary password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Set Temporary Password"
      open={isOpen}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button 
          key="submit" 
          type="primary" 
          loading={loading}
          onClick={handleSubmit}
          className="bg-blue-500"
        >
          Set Password
        </Button>
      ]}
    >
      <div className="mt-4">
        <Input.Password
          placeholder="Enter temporary password"
          value={tempPassword}
          onChange={(e) => setTempPassword(e.target.value)}
          className="w-full"
        />
      </div>
    </Modal>
  );
};

export default TempPasswordModal;